/** @format */

import { combineReducers } from '@reduxjs/toolkit';

import carBrandReducer from 'src/pages/configuration/car/slices/brand-slice';
import carModelReducer from 'src/pages/configuration/car/slices/model-slice';
import appReducer from './app-slice';

import bookingReducer from 'src/pages/booking/slices/booking-slice';
import bookingScheduleReducer from 'src/pages/management/slides/booking-schedule-slide';
import bookingNoticeReducer from 'src/layouts/dashboard/booking-notice-button/booking-notice.slice';
import userReducer from 'src/pages/management/slides/user-slide';

import apiSlice from 'src/api/api-slice';
import { reducer as managementSchedule } from 'src/slices/schedule';

export const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  carBrand: carBrandReducer,
  carModel: carModelReducer,

  schedule: managementSchedule,
  booking: bookingReducer,
  bookingSchedule: bookingScheduleReducer,
  bookingNotice: bookingNoticeReducer,
  [apiSlice.reducerPath]: apiSlice.reducer
});
